import React from 'react';
import Icon from '../../../components/AppIcon';

const DataQualityIndicator = ({ completionPercentage, completedSections, totalSections }) => {
  const getQualityStatus = () => {
    if (completionPercentage >= 80) return { label: 'Sangat Baik', color: 'success', icon: 'CheckCircle2' };
    if (completionPercentage >= 60) return { label: 'Baik', color: 'warning', icon: 'AlertCircle' };
    return { label: 'Perlu Dilengkapi', color: 'error', icon: 'XCircle' };
  };

  const status = getQualityStatus();

  return (
    <div className="card sticky top-36 lg:top-44">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Kualitas Data</h3>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-${status?.color}/10`}>
          <Icon name={status?.icon} size={16} color={`var(--color-${status?.color})`} />
          <span className={`text-sm font-medium text-${status?.color}`}>{status?.label}</span>
        </div>
      </div>
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Kelengkapan</span>
          <span className="text-2xl font-bold text-foreground">{completionPercentage}%</span>
        </div>
        <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
      </div>
      <div className="space-y-3 mb-6">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Bagian Selesai</span>
          <span className="font-medium text-foreground">{completedSections}/{totalSections}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Bagian Tersisa</span>
          <span className="font-medium text-foreground">{totalSections - completedSections}</span>
        </div>
      </div>
      <div className="pt-4 border-t border-border">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Tips Pengisian</p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Data yang lengkap dan akurat akan menghasilkan analisis AI yang lebih presisi untuk penilaian risiko bisnis Anda.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataQualityIndicator;